module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_12_3.2d63a38f.jpeg";